import { authedFetch } from './http';

type Auth = { getToken: () => string | null; hydrate: () => Promise<void> };

export type Comment = {
  id: number;
  matchNumber?: number;
  userId: string;
  nickname?: string;
  canton?: string;
  avatarUrl?: string;
  avatarCap?: string;
  body: string;
  createdAt: string;
  isMine?: boolean;
};

export type CommentThread = {
  comments: Comment[];
  enabled: boolean;
  disabledMessage?: string;
};

export function listMatchComments(auth: Auth, n: number): Promise<CommentThread> {
  return authedFetch(auth.getToken, auth.hydrate, `/api/matches/${n}/comments`);
}

export function postMatchComment(auth: Auth, n: number, body: string): Promise<Comment> {
  return authedFetch(auth.getToken, auth.hydrate, `/api/matches/${n}/comments`, {
    method: 'POST',
    body: JSON.stringify({ body }),
  });
}

export async function deleteComment(auth: Auth, id: number): Promise<void> {
  await authedFetch(auth.getToken, auth.hydrate, `/api/comments/${id}`, { method: 'DELETE' });
}

export function listLeagueComments(auth: Auth, leagueId: string): Promise<CommentThread> {
  return authedFetch(auth.getToken, auth.hydrate, `/api/leagues/${leagueId}/comments`);
}

export function postLeagueComment(auth: Auth, leagueId: string, body: string): Promise<Comment> {
  return authedFetch(auth.getToken, auth.hydrate, `/api/leagues/${leagueId}/comments`, {
    method: 'POST',
    body: JSON.stringify({ body }),
  });
}

export async function deleteLeagueComment(auth: Auth, leagueId: string, id: number): Promise<void> {
  await authedFetch(auth.getToken, auth.hydrate, `/api/leagues/${leagueId}/comments/${id}`, {
    method: 'DELETE',
  });
}

/** Adapter for <ChatPanel> backed by a match's comment thread. */
export function matchChatSource(auth: Auth, matchNumber: number) {
  return {
    key: `m${matchNumber}`,
    list: () => listMatchComments(auth, matchNumber),
    post: (body: string) => postMatchComment(auth, matchNumber, body),
    remove: (id: number) => deleteComment(auth, id),
  };
}

/** Adapter for <ChatPanel> backed by a league's members-only chat. */
export function leagueChatSource(auth: Auth, leagueId: string) {
  return {
    key: `l${leagueId}`,
    list: () => listLeagueComments(auth, leagueId),
    post: (body: string) => postLeagueComment(auth, leagueId, body),
    remove: (id: number) => deleteLeagueComment(auth, leagueId, id),
  };
}
